export default __webpack_public_path__ + "static/IBMPlexSans-Medium-Greek-abd3231b567f7a09128955d04dc06dd3.woff";